<script setup lang="ts">
import { useElementHover } from '@vueuse/core'

defineProps({
  to: {
    type: String,
    required: true,
  },
  isActive: {
    type: Boolean,
    default: false,
  },
})

const link = ref()
const isHovered = useElementHover(link)
</script>

<template>
  <LinkOrAnchor
    ref="link"
    :to="to"
    class="relative inline-block py-3 text-sm font-semibold"
  >
    <span
      :class="
        isActive || isHovered
          ? 'absolute w-full bg-p-500 py-0.5 px-2 box-content mx-auto h-6 transform left-1/2 bottom-1/2 -translate-x-1/2 translate-y-1/2 rounded-lg'
          : ''
      "
    />
    <span class="relative">
      <slot />
    </span>
  </LinkOrAnchor>
</template>
